import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ProgramComponent } from '../../shared/components/modals/program/program.component';
import { CategoriesOfListeners, CategoriesOfListenersClient, ConfirmationDocument, EducationalProgram, EducationalProgramClient, EducationForm, FileClient, SectionClient } from 'src/app/services/apis/web-api-client';
import { FileService } from 'src/app/services/file.service';
import { forkJoin } from 'rxjs';
import { ConfirmationDocumentTypes, GetConfirmationDocumentType } from 'src/app/models/enums/confirmation-document';
import { EducationForms, GetEducationForms } from 'src/app/models/enums/education-form';
@Component({
  selector: 'app-courese',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss']
})
export class CourseComponent implements OnInit {
  modalRef: BsModalRef;
  isCollapsed = true;
  isLoading = true;
  selectedEP = null;
  educationFormO = false;
  educationFormZ = false;
  educationFormDOT = false;
  educationType = null;
  listners: CategoriesOfListeners[] = [];
  selectedListner: CategoriesOfListeners = null;
  documents = ConfirmationDocumentTypes;
  educationForms = EducationForms;
  colors = ['cr1', 'cr2', 'cr3', 'cr4', 'cr5', 'cr6'];

  constructor(
    private modalService: BsModalService,
    private educationProgram: EducationalProgramClient,
    private fileService: FileService,
    private sectionService: SectionClient,
    private activateRoute: ActivatedRoute,
    private categoriesOfListenersClient: CategoriesOfListenersClient,

  ) {
  }

  educationPrograms: EducationalProgram[] = [];
  programms = [];
  sections = [];
  id = null;

  openModal(item: any) {
    const initialState = {
      list: [
        item
      ]
    };
    this.modalService.show(ProgramComponent, { initialState });
  }

  ngOnInit(): void {
    this.id = this.activateRoute.snapshot.params['id'];

    forkJoin({
      listners: this.categoriesOfListenersClient.getAll(),
      sections: this.sectionService.getAll(),
      eduPrograms: this.educationProgram.getAll()
    }).subscribe(({ listners, eduPrograms, sections }) => {
      this.listners = listners;
      this.educationPrograms = eduPrograms;
      this.sections = sections;
      this.isLoading = false;
      if (this.id != null) this.selectedEP = this.id;
    });
  };

  getImage(link) {
    return this.fileService.getDownloadUrl(link);
  }

  filterEP(section) {
    this.selectedEP = section;
  }

  getEPs() {
    let result = this.educationPrograms;
    if (this.selectedEP != null) {
      result = this.educationPrograms.filter(x => x.sectionId == this.selectedEP)
    }
    if (this.educationFormO) {
      result = result.filter(x => x.educationForm == EducationForm.FullTime)
    }
    if (this.educationFormZ) {
      result = result.filter(x => x.educationForm == EducationForm.Distant)
    }
    if (this.educationFormDOT) {
      result = result.filter(x => x.educationForm == EducationForm.DOTDistant)
    }
    if (this.selectedListner != null) {
      result = result.filter(x => x.categoriesOfListeners.map(x => x.categoriesOfListenersId).includes(this.selectedListner.id))
    }
    return result;
  }
  test(category: CategoriesOfListeners, index: number): boolean {
    // console.log(index);
    // console.log(category);
    // console.log('this.selectedListner', this.selectedListner);
    if(this.selectedListner === null && index < 4) return true;
    if(this.selectedListner === null && index >= 4) return false;
    if (this.selectedListner !== null) {
      if (index < 4) return true;
      if (index >= 4) return this.selectedListner.id === category.id;
    }


  }


  getSections() {
    // return this.sections.filter(x => this.educationPrograms.some(y => y.section.id == x.id));
    return this.sections;
  }

  getColor(i) {
    if (i % 3 == 0) return "li1";
    if (i % 3 == 1) return "li2";
    if (i % 3 == 2) return "li3";
  }

  getConfirmationDocumentType(type: ConfirmationDocument) {
    return GetConfirmationDocumentType(type)
  }

  //TODO: THIS
  getEducationForm(edt: EducationForm) {
    return GetEducationForms(edt);
  }

  getbk(i) {
    if (i % 4 == 0) return "bk1";
    if (i % 4 == 1) return "bk2";
    if (i % 4 == 2) return "bk2";
    if (i % 4 == 3) return "bk1";


  }

  getCr(i) {
    if (i % 3 == 0) return "cr1";
    if (i % 3 == 1) return "cr2";
    if (i % 3 == 2) return "cr3";

  }

  reset() {
    this.selectedEP = null;
    this.educationFormO = false;
    this.educationFormZ = false;
    this.selectedListner = null;
    // this.educationType = null;
    this.getEPs();
  }
}
